module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), (_vm.$route.params.tag_id) ? _c('div', {
    staticClass: "del-block"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mealTagInfo.name),
      expression: "mealTagInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.mealTagInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mealTagInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n      排序\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mealTagInfo.sort),
      expression: "mealTagInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "maxlength": "99",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.mealTagInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mealTagInfo, "sort", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mealTagInfo.is_visible),
      expression: "mealTagInfo.is_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mealTagInfo, "is_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("隱藏")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.mealTagInfo.icon_file) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _c('object', {
    staticStyle: {
      "width": "33px",
      "height": "33px"
    },
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.mealTagInfo.icon_file
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "meal-tag-icon-load"
    }
  }, [_vm._v("\n              選擇圖片\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "meal-tag-icon-load"
    },
    on: {
      "change": _vm.onIconChange
    }
  })])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          底圖\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.mealTagInfo.image_file) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealTagInfo.image_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.mealTagInfo.image_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "meal-tag-img-load"
    }
  }, [_vm._v("\n              選擇圖片\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "meal-tag-img-load"
    },
    on: {
      "change": _vm.onImageChange
    }
  })])])])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/mealTagTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.$route.params.tag_id) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("餐點種類")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("顯示\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖示\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖示為40x40~200x200)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(底圖大小為800x460)"), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f950833"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Platform/Temp/MealTagFormTemp.vue
// module id = 2502
// module chunks = 1